module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_3016.b384d555.png";